<template>
  <header>
    <div class="mv">
      <p class="sub_ttl wrapper">
        <img class="pc" src="@/assets/img/pc/mv01.png" alt="あなたのMyユンケルを教えてください！">
        <img class="sp" src="@/assets/img/sp/mv01.png" alt="あなたのMyユンケルを教えてください！">
      </p>
      <!-- /.sub_ttl -->
      <div class="item wrapper">
        <img class="pc" src="@/assets/img/pc/mv02.png" alt="">
        <img class="sp bottle" src="@/assets/img/sp/mv02.png" alt="">
        <h1>
          <img class="pc" src="@/assets/img/pc/mv03.png" alt="ユンケル総選挙2020">
          <img class="sp" src="@/assets/img/sp/mv03.png" alt="ユンケル総選挙2020">
        </h1>
      </div>
      <!-- /.item -->
    </div>
    <!-- /.mv -->
    <p class="period">
      <img class="pc" src="@/assets/img/pc/period.png" alt="キャンペーン期間：2020年11月1日(日）〜2021年1月31日(日）">
      <img class="sp" src="@/assets/img/sp/period.png" alt="キャンペーン期間：2020年11月1日(日）〜2021年1月31日(日）">
    </p>
    <!-- /.period -->
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>
